// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".canvas-container{position:fixed!important;bottom:0!important;left:0!important}", ""]);
// Exports
module.exports = exports;
